import * as React from 'react';
import { Card, FilesList } from '@grandvisionhq/common';
import PrescriptionTable from '../PrescriptionTable/PrescriptionTable.js';
import { PrescriptionType } from '../../models/line-item/prescription.js';

const GlassesPrescription = ({ prescription , prescriptionsUrl , intl  })=>{
    const { getLabel  } = intl;
    switch(prescription.type){
        case PrescriptionType.PRESCRIPTION_FILE:
            return /*#__PURE__*/ React.createElement(FilesList, {
                items: [
                    prescription.pupillaryDistanceFile,
                    prescription.prescriptionFile
                ]
            });
        case PrescriptionType.NEW_PRESCRIPTION:
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(PrescriptionTable, {
                className: "order-detail-card__prescription-table",
                orientation: "eyeSideTop",
                size: "narrow",
                prescription: {
                    rightEye: prescription.rightEye,
                    leftEye: prescription.leftEye
                }
            })), /*#__PURE__*/ React.createElement(Card.Section, null, prescriptionsUrl && /*#__PURE__*/ React.createElement(Card.Link, {
                variant: "caption-head",
                iconAfter: "chevron-right",
                url: prescriptionsUrl
            }, getLabel('account.order.detail.viewPrescription'))));
        case PrescriptionType.EMAIL_PRESCRIPTION:
            return /*#__PURE__*/ React.createElement(Card.Text, {
                variant: "caption"
            }, getLabel('cart.lineItem.glasses.emailPrescription.title'), ":", ' ', getLabel('cart.lineItem.glasses.emailPrescription.message'));
        case PrescriptionType.EXISTING_CUSTOMER:
            return /*#__PURE__*/ React.createElement(Card.Text, {
                variant: "caption"
            }, getLabel('cart.lineItem.glasses.noPrescription.title'), ":", ' ', getLabel('cart.lineItem.glasses.noPrescription.message'));
        default:
            return null;
    }
};

export { GlassesPrescription };
//# sourceMappingURL=GlassesPrescription.js.map
